/**
 * Labstep
 *
 * @module screens/Device/Show
 * @desc Device Show Screen
 */

import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { Device } from 'labstep-web/models/device.model';
import { DeviceShowCenter as Center } from 'labstep-web/screens/Device/Show/Center';
import { ScreensDeviceShowRight as Right } from 'labstep-web/screens/Device/Show/Right';
import MasterShow from 'labstep-web/screens/Master/Show';
import type React from 'react';
import type {
  IDeviceShowScreenContainerProps,
  IDeviceShowScreenProps,
} from './types';

export const DeviceShowScreen: React.FC<IDeviceShowScreenProps> = ({
  device,
}) => (
  <>
    <DocumentHead title={device.name} />
    <MasterShow
      entity={device}
      center={<Center device={device} />}
      right={<Right device={device} />}
    />
  </>
);

export const DeviceShowScreenContainer: React.FC<
  IDeviceShowScreenContainerProps
> = ({ match }) => (
  <ReadOnMountHOC
    type="entities"
    entityName={Device.entityName}
    params={{
      get_single: 1,
      is_deleted: 'both',
      id: match.params.id,
    }}
    loading={{ loader: 'show', cached: true }}
    children={({ entity }) => <DeviceShowScreen device={entity} />}
  />
);
